import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { listClasses, listSubjects, listStaff, setAssignedTeacher, TEACHER_DEPARTMENT } from "./happyschoolApi";
import { getActiveSchoolId } from "./activeSchool";

// Tách riêng từ "Case xếp tay" — đổi GV chính / thêm GV dự phòng cho 1
// (lớp, môn) bất kỳ, không cần khoá từng ô trong lưới trước. Trước đây
// nhét chung với lưới Case xếp tay khiến trang đó rối, giờ tách hẳn ra
// tab riêng cho gọn.
const HappySchoolPccmQuickEdit = () => {
  const schoolId = getActiveSchoolId();
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [classId, setClassId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [teacherId, setTeacherId] = useState("");
  const [saving, setSaving] = useState("");
  const [msg, setMsg] = useState("");

  const subjectsById = useMemo(() => Object.fromEntries(subjects.map((s) => [s.id, s.name])), [subjects]);

  const reload = () => {
    if (!schoolId) return;
    setLoading(true);
    setError("");
    Promise.all([listClasses(schoolId), listSubjects(schoolId), listStaff(schoolId, { department: TEACHER_DEPARTMENT })])
      .then(([c, s, t]) => {
        setClasses((c || []).slice().sort((a, b) => a.name.localeCompare(b.name, "vi", { numeric: true })));
        setSubjects(s || []);
        setStaff((t || []).slice().sort((a, b) => a.name.localeCompare(b.name, "vi")));
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  };
  useEffect(reload, [schoolId]); // eslint-disable-line

  const patchClassSubject = (cid, sid, patch) => {
    setClasses((prev) => prev.map((c) => {
      if (c.id !== cid) return c;
      return {
        ...c,
        subjects: (c.subjects || []).map((s) => (s.subjectId === sid ? { ...s, ...patch(s) } : s)),
      };
    }));
  };

  const cls = classes.find((c) => c.id === classId);
  const subjectCfg = (cls?.subjects || []).find((s) => s.subjectId === subjectId);

  const doSetAssignedTeacher = async () => {
    if (!classId || !subjectId || !teacherId) return;
    setSaving("assign");
    setMsg("");
    setError("");
    try {
      await setAssignedTeacher(schoolId, classId, subjectId, teacherId);
      patchClassSubject(classId, subjectId, (s) => ({
        assignedTeacherId: teacherId,
        poolTeacherIds: (s.poolTeacherIds || []).filter((id) => id !== teacherId),
      }));
      setMsg("Đã đặt làm GV chính.");
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving("");
    }
  };

  if (!schoolId) {
    return <div style={{ padding: 16 }}>Chưa chọn trường. Vào <Link to="/happyschool/schools">Trường của tôi</Link>.</div>;
  }
  if (loading && !classes.length) return <p>Đang tải...</p>;

  return (
    <div>
      <div style={{ marginBottom: 12, padding: "10px 12px", background: "#f5f3ff", border: "1px solid #ddd6fe", borderRadius: 8 }}>
        <div style={{ fontSize: 12, color: "#5b21b6", fontWeight: 700, marginBottom: 6 }}>🔁 Đổi GV chính cho 1 lớp-môn bất kỳ</div>
        <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
          <select value={classId} onChange={(e) => { setClassId(e.target.value); setSubjectId(""); setMsg(""); }} style={sel}>
            <option value="">— Lớp —</option>
            {classes.map((c) => (<option key={c.id} value={c.id}>{c.name}</option>))}
          </select>
          <select value={subjectId} onChange={(e) => { setSubjectId(e.target.value); setMsg(""); }} disabled={!cls} style={sel}>
            <option value="">— Môn —</option>
            {(cls?.subjects || []).map((s) => (<option key={s.subjectId} value={s.subjectId}>{subjectsById[s.subjectId] || s.subjectId}</option>))}
          </select>
          <select value={teacherId} onChange={(e) => { setTeacherId(e.target.value); setMsg(""); }} disabled={!subjectId} style={sel}>
            <option value="">— GV —</option>
            {staff.map((s) => (<option key={s.id} value={s.id}>{s.name}</option>))}
          </select>
          <button type="button" onClick={doSetAssignedTeacher} disabled={!teacherId || saving} style={btn}>
            {saving === "assign" ? "Đang lưu..." : "Đặt làm GV chính"}
          </button>
          {msg && <span style={{ fontSize: 12, color: "#059669", fontWeight: 600 }}>✓ {msg}</span>}
        </div>
        {subjectCfg && (
          <div style={{ marginTop: 6, fontSize: 12, color: "#6b7280" }}>
            Hiện tại: GV chính <strong>{staff.find((s) => s.id === subjectCfg.assignedTeacherId)?.name || "(chưa có)"}</strong>
            {" · "}{subjectCfg.periodsPerWeek || 0} tiết/tuần
          </div>
        )}
      </div>
      {error && <p style={{ color: "#dc2626", fontSize: 13 }}>{error}</p>}
    </div>
  );
};

const sel = { padding: "6px 8px", border: "1px solid #d1d5db", borderRadius: 6, fontSize: 13 };
const btn = { padding: "6px 12px", border: "1px solid #7c3aed", borderRadius: 6, fontSize: 13, background: "#7c3aed", color: "#fff", fontWeight: 600, cursor: "pointer" };

export default HappySchoolPccmQuickEdit;
